import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/payments`, parameters)
    },

    update(parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/payments`, parameters)
    },

    create(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/payments/create`,
            parameters
        )
    },

    delete(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/payments/delete`,
            parameters
        )
    },

    restore(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/payments/restore`,
            parameters
        )
    },
}
